import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle } = FiIcons;

const rules = [
  "This is the real packaging video of your order.",
  "Recorded before dispatch (Powered by ShipAssure.ShareMyImage.com).",
  "Only accept the courier in the packaging shown in the video.",
  "Share the OTP only when the courier boy is in front of you with the shipment.",
  "Do not share the OTP without reading the message; it may be for rejecting the delivery.",
  "Record a video while opening the parcel after receiving it from the courier."
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.2 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4 } }
};

export default function TrustChecklist() {
  return (
    <motion.ul 
      variants={containerVariants} 
      initial="hidden" 
      animate="show" 
      className="space-y-3"
    >
      {rules.map((rule, idx) => (
        <motion.li 
          key={idx} 
          variants={itemVariants} 
          className="flex items-start p-4 rounded-2xl bg-slate-50 border border-slate-100 hover:bg-blue-50/50 hover:border-blue-100 transition-all duration-300 group"
        >
          <span className="flex-shrink-0 mt-0.5 bg-white rounded-full shadow-sm">
            <SafeIcon 
              icon={FiCheckCircle} 
              className="text-xl text-blue-600 group-hover:scale-110 transition-transform duration-300" 
            />
          </span>
          <span className="ml-4 text-sm text-slate-700 leading-relaxed font-medium">
            {rule.split(/(OTP|ShipAssure\.ShareMyImage\.com)/g).map((part, i) => {
              if (part === 'OTP') {
                return <strong key={i} className="text-slate-900 font-extrabold bg-slate-200/50 px-1.5 py-0.5 rounded">{part}</strong>;
              }
              if (part === 'ShipAssure.ShareMyImage.com') {
                return <span key={i} className="text-blue-600 font-bold">{part}</span>;
              }
              return part;
            })}
          </span>
        </motion.li>
      ))}
    </motion.ul>
  );
}